import { assign, each, flatMap, mapValues, reduce, sortBy, uniq } from 'lodash'

const pushOrCreateKey = (obj, value, name) => {
  const found = obj[name]

  if (found) {
    return found.push(value)
  }

  return assign(obj, { [name]: [value] })
}

const uniqSortedValues = values => {
  return sortBy(uniq(values))
}

const toObject = (attributes, attribute) => {
  const { name, value } = attribute

  return assign(attributes, { [name]: value })
}

const refineAttributes = variant => {
  const { attributes } = variant

  const refinedAttributes = reduce(attributes, toObject, {})

  assign(variant, { refinedAttributes })
}

const reduceAttributes = (result, attribute) => {
  each(attribute, pushOrCreateKey.bind(null, result))

  return result
}

const groupVariantsAttributes = variants => {
  const attributes = flatMap(variants, 'refinedAttributes')

  const reduced = reduce(attributes, reduceAttributes, {})

  return mapValues(reduced, uniqSortedValues)
}

const setVariantsAttributes = product => {
  const { variants } = product

  const related = [product, ...variants]

  each(related, refineAttributes)

  assign(product, {
    variantsAttributes: groupVariantsAttributes(related),
  })
}

export default setVariantsAttributes
